/* unplugin-vue-components disabled */import { render } from "./jobs.vue?vue&type=template&id=424f6640&scoped=true"
import script from "./jobs.vue?vue&type=script&lang=js"
export * from "./jobs.vue?vue&type=script&lang=js"

import "./jobs.vue?vue&type=style&index=0&id=424f6640&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424f6640"],['__file',"src/components/cards/persona/jobs/jobs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "424f6640"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('424f6640', __exports__)) {
    api.reload('424f6640', __exports__)
  }
  
  module.hot.accept("./jobs.vue?vue&type=template&id=424f6640&scoped=true", () => {
    api.rerender('424f6640', render)
  })

}


export default __exports__